import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twentyseventheme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Clean Slate */
            --bg: #f9fafb;
            --surface: #ffffff;
            --text: #374151;
            --primary: #3b82f6;
            --border: #e5e7eb;
        }

        body { font-family: 'Inter', sans-serif; background: var(--bg); color: var(--text); margin: 0; line-height: 1.5; }
        a { text-decoration: none; color: inherit; transition: 0.2s; }
        a:hover { color: var(--primary); }
        .container { max-width: 1000px; margin: 0 auto; padding: 0 20px; }
        
        .header { background: var(--surface); border-bottom: 1px solid var(--border); padding: 20px 0; }
        .header .container { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-weight: 700; font-size: 1.25rem; color: #111; }
        .nav { display: flex; gap: 20px; font-size: 0.9rem; color: #6b7280; }
        
        .hero { background: var(--surface); padding: 80px 0; text-align: center; border-bottom: 1px solid var(--border); }
        .hero h1 { font-size: 2.5rem; font-weight: 800; color: #111; margin-bottom: 15px; }
        .hero p { color: #6b7280; max-width: 600px; margin: 0 auto 30px; }
        
        .btn { display: inline-block; background: var(--primary); color: white; padding: 10px 20px; border-radius: 6px; font-weight: 500; font-size: 0.9rem; border: none; cursor: pointer; transition: 0.2s; }
        .btn:hover { background: #2563eb; color: white; }
        .btn-text { background: transparent; color: var(--primary); padding: 0; }
        .btn-text:hover { text-decoration: underline; background: transparent; color: var(--primary); }
        
        .section { padding: 60px 0; }
        .section h2 { font-size: 1.5rem; font-weight: 700; margin-bottom: 30px; color: #111; }
        
        .list-grid { display: grid; gap: 20px; }
        .list-item { background: var(--surface); padding: 20px; border: 1px solid var(--border); border-radius: 8px; display: flex; align-items: center; gap: 20px; }
        .icon-box { min-width: 50px; height: 50px; background: #eff6ff; color: var(--primary); border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; }
        
        .product-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 20px; }
        .product-card { background: var(--surface); border: 1px solid var(--border); border-radius: 8px; overflow: hidden; }
        .product-img { width: 100%; height: 150px; object-fit: cover; background: #f3f4f6; }
        .product-body { padding: 15px; }
        .product-body h3 { font-size: 1rem; font-weight: 600; margin-bottom: 5px; }
        .price { font-weight: 700; color: #111; font-size: 0.9rem; }
        
        .footer { border-top: 1px solid var(--border); padding: 40px 0; text-align: center; font-size: 0.85rem; color: #9ca3af; background: var(--surface); margin-top: 60px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

            <div className="header">
                <div className="container">
                    <div className="brand">{get_data.service_name}</div>
                    <nav className="nav">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                    </nav>
                </div>
            </div>

            <div className="hero">
                <div className="container">
                    <h1>Simply Better.</h1>
                    <p>We focus on what matters: delivering excellence without the noise. High quality services for high quality needs.</p>
                    <a href="#products" className="btn">View Products</a>
                </div>
            </div>

            <div className="container section" id="services">
                <h2>Our Expertise</h2>
                <div className="list-grid">
                    {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="list-item" key={index}>
                            <div className="icon-box">
                                {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '30px', height: '30px'}} alt=""/> : <span>✓</span>}
                            </div>
                            <div>
                                <h3 style={{fontSize: '1.1rem', fontWeight: 600, margin: '0 0 5px'}}>{item.name}</h3>
                                <p style={{margin: 0, fontSize: '0.9rem', color: '#6b7280'}}>{item.description}</p>
                            </div>
                            <div style={{marginLeft: 'auto'}}>
                                <a href={`tel:${get_data.mobile}`} className="btn-text" style={{marginRight: '15px'}}>Call</a>
                                <a href="#contact" className="btn-text">Details &rarr;</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                            </div>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="container section" id="products">
                <h2>Featured Items</h2>
                <div className="product-grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="product-card" key={index}>
                            {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>) : (<div className="product-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                            <div className="product-body">
                                <h3>{item.service_name}</h3>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px'}}>
                                     {item.price && <span className="price">₹{item.price}</span>}
                                     <button onClick={() => addToCart(item)} className="btn" style={{padding: '5px 12px', fontSize: '0.8rem'}}>Add</button>
                                </div>
                            </div>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                <div className="container">
                    <p>{get_data.service_name} &nbsp; • &nbsp; {get_data.business_location_name}</p>
                    <p>{get_data.email}</p>
                </div>
            </footer>
        </>
    );
};

export default Twentyseventheme;
